import { useState, useEffect } from "react";
import { Button } from "ui/compat";
import { ExampleNoticeWrapper } from "styles";

export const ExampleNotice = ({ projectSlug }) => {
  const [showConsent, setShowConsent] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(`ExampleNotice.${projectSlug}`);
    if (!consent) {
      setShowConsent(true);
    }
    // eslint-disable-next-line
  }, []);

  const handleAccept = () => {
    localStorage.setItem(`ExampleNotice.${projectSlug}`, "hide");
    setShowConsent(false);
  };

  if (!showConsent) return null;

  return (
    <ExampleNoticeWrapper>
      <div>
        <h6>This is an example project</h6>
        <p>
          No data filled on this page will be submitted or addressed.
          <br />
          From time to time, we offer our customers to share their projects and
          use it to showcase the platform pages in action. This is an example of
          such a project.
        </p>
      </div>

      <Button secondary size="small" onClick={handleAccept}>
        Hide notice
      </Button>
    </ExampleNoticeWrapper>
  );
};
